import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { User, Briefcase, Building2, Store, Factory } from "lucide-react";

export default function Step1Type() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);

  const types = [
    {
      id: "pf",
      title: "Pessoa Física",
      icon: <User className="w-5 h-5" />,
      description:
        "Ideal para quem vende sem CNPJ, mas quer começar de forma simples e profissional. A disponibilidade de um endereço é obrigatória.",
    },
    {
      id: "mei",
      title: "MEI (Microempreendedor Individual)",
      icon: <Briefcase className="w-5 h-5" />,
      description:
        "O MEI é o pequeno empresário que atua com CNPJ e pode emitir notas fiscais. Dentro da plataforma, vendedores com porte de MEI possuem acesso à emissão de notas e relatórios básicos. A disponibilidade de um endereço é obrigatória.",
    },
    {
      id: "me",
      title: "Microempresa",
      icon: <Store className="w-5 h-5" />,
      description:
        "Dentro da plataforma, vendedores com porte de ME possuem acesso à emissão de notas, relatórios detalhados e controle de colaboradores. A disponibilidade de um endereço é obrigatória.",
    },
    {
      id: "epp",
      title: "Empresa de Pequeno Porte",
      icon: <Building2 className="w-5 h-5" />,
      description:
        "Dentro da plataforma, vendedores com porte de EPP possuem acesso a relatórios financeiros, dashboards personalizados e integração com sistemas de gestão. A disponibilidade de um endereço é obrigatória.",
    },
    {
      id: "emp",
      title: "Empresa de Médio ou Grande Porte",
      icon: <Factory className="w-5 h-5" />,
      description:
        "Empresas com estrutura mais complexa e maior volume de operações, com acesso a módulos avançados e suporte prioritário. A disponibilidade de um endereço é obrigatória.",
    },
  ];

  const handleNext = () => {
    if (!selected) return;

    const selectedId = selected.id;
    const selectedTitle = selected.title;

    // Persist store type choice for final assembly
    try {
      const { saveStepData } = require("../../services/storeCreationService");
      saveStepData("step1", { storeType: selectedId, storeTypeTitle: selectedTitle });
    } catch {}

    if (selectedId === "pf") {
      navigate("/create-store/step2-individual", {
        state: { selectedId, selectedTitle },
      });
    } else {
      navigate("/create-store/step2-company", {
        state: { selectedId, selectedTitle },
      });
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div className="flex flex-col items-center min-h-screen px-4 bg-white pt-6 pb-8">
      <div className="w-full max-w-md flex items-center mb-2">
        <button onClick={handleBack} className="text-gray-600 mr-2">&larr;</button>
        <h1 className="text-xl font-bold text-gray-800">Criar loja</h1>
      </div>
      <h2 className="text-xl font-bold text-gray-800 mt-1">Qual é o porte da sua empresa?</h2>
      <p className="text-sm text-gray-600 mt-1">Escolha o mais compatível.</p>

      <div className="w-full max-w-md grid grid-cols-2 gap-3 mt-5">
        {types.map((type) => {
          const isSelected = selected?.id === type.id;
          return (
            <button
              key={type.id}
              onClick={() => setSelected(type)}
              className={`w-full border rounded-xl py-5 px-4 text-sm font-medium transition-all text-left shadow-sm ${
                isSelected
                  ? "border-purple-500 bg-purple-50"
                  : "border-gray-200 bg-gray-50"
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-2 ${
                isSelected ? "bg-purple-100 text-purple-700" : "bg-gray-100 text-gray-500"
              }`}>{type.icon}</div>
              <span className={`${isSelected ? "text-purple-700" : "text-gray-700"}`}>{type.title}</span>
            </button>
          );
        })}
      </div>

      {selected && (
        <div className="mt-6 max-w-md text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-xl p-4">
          <p className="mb-2 font-semibold text-gray-800">Por que escolher "{selected.title}"?</p>
          <p>{selected.description}</p>
        </div>
      )}

      <button
        onClick={handleNext}
        disabled={!selected}
        className={`mt-6 w-full max-w-md py-3 rounded-lg font-semibold transition-all ${
          selected
            ? "bg-purple-600 text-white hover:bg-purple-700"
            : "bg-purple-200 text-white cursor-not-allowed"
        }`}
      >
        Prosseguir
      </button>
    </div>
  );
}
